import { ITrackingLink } from '../models';

export function fromJsonApi(data: any, included: any[]): ITrackingLink {
  const id = data.id || '';
  const attributes = data.attributes || {};

  return {
    id,
    name: attributes.name || '',
    phone: attributes.phone || attributes.phone_number || '',
    status: attributes.status || '',
    brokerLogo: attributes.logo || (attributes.metadata && attributes.metadata.logo) || '',
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/trackingLink.ts